import React, {Component} from 'react';
import PropTypes from 'prop-types';
import './RegisterApplicant.css';
import PersonalData from './../personalData/PersonalData.container';
import {PERSONAL_FORM_MODE} from './../personalData/PersonalData';
import {Button, Form, Input, Label} from 'reactstrap';
import _ from 'lodash';
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';
import LicenseAgreementModal from '../../commonComponents/licenseAgreement/LicenseAgreementModal.container';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";

const requiredSelectFields = ['countryCode'];

class RegisterApplicant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            countryCode: '',
            isAgreeWithLicense: false,
            success: false,
            requiredFieldError: null
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.success && !this.props.success) {
            this.setState({success: true});
        }
    }

    render() {
        if (this.state.success) {
            return (
                <div>
                    <BackButtonComponent path='/login'
                                         label={_.get(this.props.translation, 'register_applicant.back_button')}/>
                    <h6 className="text-center succes-message-header">
                        {_.get(this.props.translation, 'register_applicant.success_message')}
                    </h6>
                </div>
            )
        }
        return (
            <div className="register-applicant-container">
                <FormWrapper successMessage={_.get(this.props.translation, 'register_applicant.success_message')}>
                    <BackButtonComponent path='/login'
                                         label={_.get(this.props.translation, 'register_applicant.back_button')}/>
                    <h4 className='text-center'>{_.get(this.props.translation, 'register_applicant.label')}</h4>
                    <div className="register-applicant-form">
                        <Form onSubmit={this.onRegister}>
                            <h6>{_.get(this.props.translation, 'register_applicant.message')}</h6>
                            <PersonalData
                                handleChange={this.handleChange}
                                handleChangeByValue={this.handleChangeByValue}
                                firstName={this.state.firstName}
                                lastName={this.state.lastName}
                                email={this.state.email}
                                isEmailEditable={true}
                                phoneNumber={this.state.phoneNumber}
                                countryCode={this.state.countryCode}
                                requiredFields={['firstName', 'lastName', 'email', 'continentCode', 'countryCode']}
                                requiredFieldError={this.state.requiredFieldError}
                                mode={PERSONAL_FORM_MODE}
                            />
                            <div className="submit-register-applicant-container">
                                <div className="register-applicant-license-agreement-container">
                                    <Label className='checkbox-label'>
                                        <Input
                                            type="checkbox"
                                            checked={this.state.isAgreeWithLicense}
                                            onChange={this.handleChangeAgreement}
                                        />
                                        {_.get(this.props.translation, "license_agreement.agree_label")}
                                        <a href="" className="register-applicant-license-agreement-link" onClick={this.handleClickLicenseAgreement}>
                                            {_.get(this.props.translation, "license_agreement.agree_link")}
                                        </a>
                                    </Label>                                    
                                </div>
                                <Button type="submit" className="olive-green-btn"
                                        disabled={!this.state.isAgreeWithLicense}>{_.get(this.props.translation, 'register_applicant.submit_button')}</Button>
                            </div>
                        </Form>
                    </div>
                </FormWrapper>
                <LicenseAgreementModal onAgree={this.handleAgree}/>
            </div>
        );
    }

    handleChange = (fieldKey) => (e) => {
        this.setState({[fieldKey]: e.target.value});
    };

    handleAgree = () => {
        this.setState({isAgreeWithLicense: true});
    };

    handleChangeAgreement = () => {
        this.setState({isAgreeWithLicense: !this.state.isAgreeWithLicense});
    };

    handleChangeByValue = (fieldKey) => (value) => {
        this.setState({[fieldKey]: value});
    };

    handleClickLicenseAgreement = (e) => {
        e.preventDefault();

        this.props.onShowLicenseAgreement();
    };

    onRegister = (e) => {
        e.preventDefault();

        if (!this.checkRequiredSelectFields()) {
            let data = {
                email: this.state.email,
                identityAlias: {}
            };

            let personalDataFields = ['firstName', 'lastName', 'phoneNumber', 'countryCode'];

            _.map(personalDataFields, (fieldName) => {
                if (!_.isEmpty(this.state[fieldName])) {
                    data.identityAlias[fieldName] = this.state[fieldName];
                }
            });

            this.props.onRegister(data);
        }
    };

    checkRequiredSelectFields = () => {
        let error = null;
        _.map(requiredSelectFields, field => {
            if (!this.state[field] && !error) {
                error = field;
            }
        });
        this.setState({requiredFieldError: error});
        return error;
    }
}

RegisterApplicant.propTypes = {
    translation: PropTypes.object.isRequired,
    onRegister: PropTypes.func.isRequired,
    success: PropTypes.bool,
    onShowLicenseAgreement: PropTypes.func.isRequired
};

export default RegisterApplicant;



// WEBPACK FOOTER //
// ./src/components/accountManagement/registerApplicant/RegisterApplicant.js